import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column footer-logo-column">
            <div className="footer-logo">
              <img 
                src="/Footer-logo.png" 
                alt="AstroIndia" 
                className="footer-logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <span className="footer-logo-text" style={{display: 'none'}}>AstroIndia</span>
            </div>
            <p className="footer-tagline">
              India's Most Trusted Platform. Astroindia brings ancient Vedic wisdom into India's fastest growing astrology platform.
            </p>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-column-title">Company</h3>
            <ul className="footer-links">
              <li><a href="https://astroindia.netsolutionindia.com/about" target="_blank" rel="noopener noreferrer">About Us</a></li>
              <li><a href="https://astroindia.netsolutionindia.com/applications" target="_blank" rel="noopener noreferrer">Applications</a></li>
              <li><a href="https://astroindia.netsolutionindia.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-column-title">Support</h3>
            <ul className="footer-links">
              {/* <li><a href="#help" target="_blank" rel="noopener noreferrer">Help Center</a></li> */}
              <li><a href="https://astroindia.netsolutionindia.com/help-and-support" target="_blank" rel="noopener noreferrer">Contact Us</a></li>
              <li><a href="https://astroindia.netsolutionindia.com/terms-conditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a></li>  
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 Astroindia. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
